module.exports = __webpack_public_path__ + "img/top-bg.152316af.png";